import { type PortableTextComponentProps } from '@portabletext/react'
import { type ToolkitPortableTextList } from '@portabletext/toolkit'

type BulletListProps = PortableTextComponentProps<ToolkitPortableTextList>

const BulletList = ({ children }: BulletListProps) => {
  return <ul>{children}</ul>
}

export default BulletList
